const loadingLabel = "Laden";
const nlNL = {
  loadingLabel
};
export {
  nlNL as default,
  loadingLabel
};
